import React, { Component } from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import { dimensions } from '../../style';
import Lightbox from 'react-image-lightbox';

const gutter = {
	small: 6,
	large: 8,
};

//anchor
const Thumbnail = glamorous.a({
	boxSizing: 'border-box',
	display: 'block',
	float: 'left',
	lineHeight: 0,
	paddingRight: gutter.small,
	paddingBottom: gutter.small,
	overflow: 'hidden',
	width: '33.333%',

	[dimensions.SCREEN_MIN_SM]: {
		paddingRight: gutter.large,
		paddingBottom: gutter.large,
		width: '25%'
	},
}, ({isLandscape}) => {
	if(isLandscape)
		return {
			width: '30%'
		}
});

// thumbnail container
const ThumbContainer = glamorous.div({
	position: 'relative',
});

// actual <img />
const ImageSource = glamorous.img({
	border: 0,
	display: 'block',
	height: 'auto',
	maxWidth: '100%',
	width: '100%'
});

const GalleryContainer = glamorous.div({
	marginRight: -gutter.small,
	overflow: 'hidden',

	[dimensions.SCREEN_MIN_MD]: {
		marginRight: -gutter.large,
	}
});

class Gallery extends Component {

	renderGallery () {
		const {
			images,
			openLightbox
		} = this.props;

		if (!images) return null;

		const gallery = images.map((obj, i) => {
			const orientation = obj.orientation ? obj.orientation.toLowerCase() : null;

			return (
				<Thumbnail
					href={obj.src}
					key={i}
					onClick={(e) => {e.preventDefault(); openLightbox(i, e)} }
					isLandscape={orientation === 'landscape'}
				>
					<ThumbContainer>
						<ImageSource src={obj.thumbnail} alt="thumbnail" />
					</ThumbContainer>
				</Thumbnail>
			);
		});

		return (
			<GalleryContainer>
				{gallery}
			</GalleryContainer>
		);
	}

	render () {
		return (
			<div className="section">
				{this.renderGallery()}
			</div>
		);
	}
};

Gallery.displayName = 'Gallery';
Gallery.propTypes = {
	heading: PropTypes.string,
	images: PropTypes.array,
	showThumbnails: PropTypes.bool,
	subheading: PropTypes.string,
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/common/Gallery.jsx